// This function allow to reference all chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "umi") return "umi.js";
	// return url for filenames based on template
	return chunkId + ".async.js";
};